import axios from 'axios';
import { Country } from '@/models/country';

const apiHost = process.env.VUE_APP_API_HOST;

export const checkPromo = async (currency: string, country: Country, phonenumber: string, code: string) => {
  const response = await axios.post(`${apiHost}/ringcredible/v5/websiteshop/validate_promocode`, {
    currency,
    country: country.code,
    phonenumber,
    promocode: code,
  });
  return response.data;
};
